import { createAsyncThunk } from "@reduxjs/toolkit";
import { PushNotificationActions } from "./PushNotificationSlice";
import { DATE_FORMATS } from "src/shared/config/src";
import { dateFormatter } from "src/shared/utils/src";
import { deRegisterFCMOnServer, registerFCMOnServer } from "src/shared/services/src";

export const registerForFCM = createAsyncThunk(
    "registerFCM", async ({ fcmToken, deviceId, platform }: { fcmToken: string, platform: string, deviceId: string }, { dispatch }) => {
        try {
            const payload = {
                "deviceType": platform,
                "deviceToken": fcmToken,
                "deviceId": deviceId,
                "timestamp": dateFormatter(new Date(), DATE_FORMATS.YMD_HMS)
            };
            const response = await registerFCMOnServer(payload);
            console.log("response from register api : ", response);
            await dispatch(PushNotificationActions.setFcmToken({ fcmToken }));
            // update the last token update time 
            dispatch(PushNotificationActions.setLastFCMTokenUpdateTime(new Date().getTime()));

        } catch (error) {
            console.log("error in regioster fcm api : ", JSON.stringify(error));
            await dispatch(PushNotificationActions.setFcmToken({ fcmToken: '' }));
        }
    }
);

export const deRegisterForFCM = createAsyncThunk(
    "deRegisterForFCM", async ({ deviceId, platform }: { platform: string, deviceId?: string }, { dispatch }) => {
        try {
            const payload = {
                "deviceType": platform,
                "deviceId": deviceId,
            };
            const response = await deRegisterFCMOnServer(payload);
            console.log("response from de-register api : ", response);
        } catch (error) {
            console.log("error in regioster fcm api : ", error, (error as any).response);
        } finally {
            await dispatch(PushNotificationActions.setFcmToken({ fcmToken: '' }));
        }
    }
);